import { getItemStatusCode, isBrPendingCode } from '../../../constants/brStatus';
import { getBrExpiryDateMinIso } from '../../../constants/brPure';
import { normalizeNameForCompare } from '../../../constants/brList';

/**
 * 提交确认页：表单是否可提交（与 UI 校验一致）。
 */

/**
 * 同公司列表中：相同 Registration No. 且状态为审批中 / 人工审批中的记录。
 */
export function findPendingBrDuplicatesByRegistrationNo(items, registrationNo) {
  const target = normalizeNameForCompare(registrationNo);
  if (!target) {
    return [];
  }
  return (Array.isArray(items) ? items : []).filter((item) => {
    if (!isBrPendingCode(getItemStatusCode(item))) {
      return false;
    }
    const no = normalizeNameForCompare(item?.registrationNo || item?.RegistrationNo);
    return no && no === target;
  });
}

export function canSubmitBrConfirmForm(form, scanBlockerKeys = []) {
  if ((scanBlockerKeys || []).length) {
    return false;
  }
  return !Object.keys(getBrConfirmFieldErrors(form)).length;
}

/**
 * 确认页字段级错误（用于禁用提交等）。
 * 企业名 / 注册号的红字展示由表单「触碰后再显示」，避免扫描空提取立刻报 required。
 */
export function getBrConfirmFieldErrors(form) {
  const errors = {};
  if (!form?.registeredCompanyName?.trim()) {
    errors.registeredCompanyName = true;
  }
  if (!form?.registrationNo?.trim()) {
    errors.registrationNo = true;
  }
  if (!form?.displayNameEn?.trim()) {
    errors.displayNameEn = true;
  }
  if (!form?.displayNameZh?.trim()) {
    errors.displayNameZh = true;
  }
  if (form?.hasExpirationDate) {
    const start = String(form.startDate || '').trim();
    const end = String(form.expirationDate || '').trim();
    const minExpiry = getBrExpiryDateMinIso();
    // 起迄必填；生效日不晚于到期日；到期日 ≥ 今天
    if (!start || !end || start > end || end < minExpiry) {
      errors.datePeriod = true;
    }
  }
  return errors;
}

export function createEmptyBrConfirmForm() {
  return {
    registeredCompanyName: '',
    registrationNo: '',
    hasExpirationDate: false,
    startDate: '',
    expirationDate: '',
    displayNameEn: '',
    displayNameZh: '',
  };
}
